(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Hover to open header menus with smooth animation
  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    if (details.dataset.hoverInitialized) return;
    details.dataset.hoverInitialized = 'true';

    let closeTimeout;
    const content = details.querySelector('.mega-menu__content');
    
    const openMenu = () => {
      clearTimeout(closeTimeout);
      
      // EXCLUSIVE OPEN: Close all other open menus immediately
      document.querySelectorAll('.header__inline-menu details[open]').forEach((other) => {
        if (other !== details) {
          other.removeAttribute('open');
          other.classList.remove('menu-animating-in', 'menu-animating-out');
        }
      });

      details.setAttribute('open', '');
      requestAnimationFrame(() => {
        details.classList.add('menu-animating-in');
        details.classList.remove('menu-animating-out');
      });
    };
    
    const closeMenu = () => {
      details.classList.remove('menu-animating-in');
      details.classList.add('menu-animating-out');
      
      closeTimeout = setTimeout(() => {
        // Check if any other menu has been opened during the grace period
        const isAnotherOpen = Array.from(document.querySelectorAll('.header__inline-menu details[open]')).some(d => d !== details);
        
        // Double check if we are still hovering any part of the menu
        if (isAnotherOpen || (!details.matches(':hover') && (!content || !content.matches(':hover')))) {
          details.removeAttribute('open');
          details.classList.remove('menu-animating-out');
        } else {
          // Stay open and restore state
          details.classList.remove('menu-animating-out');
          details.classList.add('menu-animating-in');
        }
      }, 500); // Reduced to 500ms for more snappy feel
    };

    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', closeMenu);
    
    if (content) {
      content.addEventListener('mouseenter', openMenu);
      content.addEventListener('mouseleave', closeMenu);
    }
  });

  // Brand Mega Menu hover logic
  document.querySelectorAll('.mega-menu__brand-item').forEach((item) => {
    item.addEventListener('mouseenter', () => {
      const container = item.closest('.mega-menu__container--brands');
      if (!container) return;

      // Aktive Kategorie markieren
      container.querySelectorAll('.mega-menu__brand-item').forEach((i) => i.classList.remove('is-active'));
      item.classList.add('is-active');

      const content = container.closest('.mega-menu__content');
      const dynamicTitle = content.querySelector('.mega-menu__brand-current-category');
      const separator = content.querySelector('.mega-menu__brand-current-separator');

      const gridContainer = container.querySelector('.mega-menu__brand-grid-container');
      const targetId = item.getAttribute('data-brand-grid');
      const targetGrid = container.querySelector(`#${targetId}`);

      if (targetGrid) {
        container.querySelectorAll('.mega-menu__brand-grid').forEach((grid) => grid.classList.remove('is-active'));
        targetGrid.classList.add('is-active');
        if (gridContainer) gridContainer.classList.add('is-visible');

        const categoryTitle = item.getAttribute('data-category-title');
        if (dynamicTitle && categoryTitle) {
          dynamicTitle.textContent = categoryTitle;
          if (separator) separator.style.display = 'inline';
        }
      }
    });
  });

 // Erste Kategorie beim Öffnen vorbelegen
  document.querySelectorAll('.mega-menu__container--brands').forEach((container) => {
    const first = container.querySelector('.mega-menu__brand-item');
    if (first) first.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();
})();
